import type { OnlineSales } from '../lib/types.ts';

/** Shown while online sales are closed and the publisher sent no message of its own. */
export const ONLINE_SALES_CLOSED_MESSAGE = 'Der er lukket for online billetsalg.';

export interface OnlineSalesView {
  readonly open: boolean;
  /** The message to show instead of ticket cards / buy buttons; null while open. */
  readonly message: string | null;
}

const OPEN: OnlineSalesView = { open: true, message: null };

/**
 * Resolves whether tickets can be bought online right now from the published `onlineSales`
 * blocks. Between this year's online sale closing and next year's opening the BackOffice bakes
 * `open: false` into tickets.json and into every ticket section; the block is absent the rest of
 * the year (and in older files), which means open. A closed block from any source wins, so a
 * section published before the sale closed still shows the message once tickets.json says so.
 */
export function resolveOnlineSales(...blocks: readonly (OnlineSales | undefined)[]): OnlineSalesView {
  const closed = blocks.find(b => b !== undefined && b.open === false);
  if (!closed) return OPEN;
  const message = typeof closed.message === 'string' && closed.message.trim().length > 0
    ? closed.message.trim()
    : ONLINE_SALES_CLOSED_MESSAGE;
  return { open: false, message };
}
